import React, { ReactElement } from 'react';
import RadioTile from '@ramsey-design-system/radio-tile';
import { FormikFormMultiField } from '../FormikFormMultiField';
import { Field, useFormikContext } from 'formik';
import { CoverageCheckupState } from '../../../store/step';

interface YesOrNoStepCreatorProps {
  showNotSure?: boolean | false;
  name: keyof CoverageCheckupState;
}

function YesOrNoStepCreator({
  showNotSure,
  name,
}: YesOrNoStepCreatorProps): ReactElement {
  const { values } = useFormikContext<CoverageCheckupState>();
  return (
    <>
      <FormikFormMultiField<CoverageCheckupState> name={name} as="fieldset">
        <Field
          as={RadioTile}
          name={name}
          label="Yes"
          value="yes"
          data-testid="yes"
          checked={values[name] === 'yes'}
          size="sm"
          className="max-w-[300px]"
        />
        <Field
          as={RadioTile}
          name={name}
          label="No"
          value="no"
          data-testid="no"
          checked={values[name] === 'no'}
          className="mt-2 max-w-[300px]"
          size="sm"
        />
        {showNotSure && (
          <Field
            as={RadioTile}
            name={name}
            label="I'm not sure"
            value="not_sure"
            data-testid="notSure"
            checked={values[name] === 'not_sure'}
            className="mt-2 max-w-[300px]"
            size="sm"
          />
        )}
      </FormikFormMultiField>
    </>
  );
}

export { YesOrNoStepCreator };
